import { getAxiosClient } from "../../axios-client";
import {
  GenerateOfferForWarehouseRequestBody,
  GenerateOfferForWarehouseResponse,
} from "./types";

const axiosClient = getAxiosClient();
export const generateOfferForWarehouse = async (
  body: GenerateOfferForWarehouseRequestBody
) => {
  return await axiosClient.ax.post<GenerateOfferForWarehouseResponse>(
    "/Offers/GenerateOfferForWarehouseOffer",
    body
  );
};
